import mod from "-!./ShareUI.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./ShareUI.js?vue&type=script&lang=js&external"